import {useLocalizationStore} from "@/stores/localization";
import {inject} from "vue";
import {useDialogManagerStore} from "@/stores/dialog-manager";
import SummaryTravelsolutionChosen from "@/common-components/dialogs/summary-travelsolution-chosen.vue";


export function wrapArray(item){
	if(!item) return [];
	return Array.isArray(item) ? item : [item];
}

export function printCurrencyValue(value, currency = 'EUR'){
	const localization = useLocalizationStore();
	currency = localization.currency;
	const currencyFormatter = new Intl.NumberFormat(undefined, { style: 'currency', currency});
	return currencyFormatter.format(value);
}

// TODO: DA APPLICARE AD OGNI RICERCA PER OTTIMIZZARE LA USER EXPERIENCE
/**
 * Confronta il criterio di ricerca con quello salvato in sessione e se corrispondono cerca e ritorna i dati della
 * risposta, del server, salvati in sessione.
 * Altrimenti ritorna false in modo che possa essere fatta nuovamente una request
 */
export function sessionStorage_SearchAndRetrive(storageHook, requestData, searchAndSave = true){
	// if(!import.meta.env.DEV) return false;
	let storedRequest = sessionStorage.getItem(storageHook + '-request');
	 // Se non c'è un criterio di ricerca o non corrisponde con quello salvato in sessione, lo salva e ritorna false in
	 // modo che si possa procedere con la ricerca e salvare in sessione i risultati
	if (!storedRequest || storedRequest != JSON.stringify(requestData)) {
		if (searchAndSave) sessionStorage.setItem(storageHook + '-request', JSON.stringify(requestData));

		return false;
	}

	// Appurato che il criterio di ricerca corrisponde cerca di recuperare i risultati dalla sessione
	let storedResponse = sessionStorage.getItem(storageHook);
	if (storedResponse) {
		return JSON.parse(storedResponse);
	} else {
		return false;
	}
}

export function convertServersSpecialCharacters(phrase) {
	return phrase.replace(/&amp;#39;/g, "'").replace(/&egrave;/g, "è").replace(/&ugrave;/g, "ù").replace(/e&#39;/, 'è').replace(/u&#39;/, 'ù');
}

/**
 * @deprecated
 */
export async function getCountriesList() {
	const countries = sessionStorage.getItem('countries');
	if (countries) return JSON.parse(countries);
	const axios = inject('axios');

	const response = await axios.post('trenitalia/get-countries', {}).catch(e => {
		console.error('loadCountries error', e);
	});
	if (response) sessionStorage.setItem('countries', JSON.stringify(response.data));

	await Promise.resolve(); // wait for getters to be updated

	return response.data;
}

/**
 * @deprecated
 */
export async function showTravelSolutionSelectedDetails(props) {
	return useDialogManagerStore()
	.openSimpleMessageDialog(props, true, SummaryTravelsolutionChosen)
	.catch(e => {
		// confirmLoading.value = false;
		console.error('error - showTravelSolutionSelectedDetails', e);
	});
}

export function capitalizeFirstLetter(word) {
	return word.charAt(0).toUpperCase() + word.slice(1);
}

/**
 * Format: dd/mm/yyyy
 * 
 * @param {string} date 
 */
export function parseBirthdate(date) {
	const birthDateParts = date.split('/');
	if(birthDateParts.length != 3) return false;
	
	return new Date(birthDateParts.reverse().join('-'));
}

export function sessionStorage_lifeManagement() {
	// TODO: VEDI CHAT CON SERGIO (PINNED)
	return props.modelValue.toLocaleTimeString(undefined, {minute: '2-digit', hour: '2-digit', hour12: false});

// function inputUpdate(timeText){
	// if(!timeText) return;
	// const parts = timeText.split(':').map(Number).filter(p => !isNaN(p));
	// if(!parts || parts.length != 2) return;
	// if(parts[0] < 0 || parts[0] > 24) return;
	// if(parts[1] < 0 || parts[1] > 59) return;
	// const newDate = new Date(props.modelValue);
	
	// newDate.setMinutes(parts[1]);
	// newDate.setHours(parts[0]);


	// const
	// const created_at = sessionStorage.getItem('sessionLife');
	// if (!created_at) {
	// 	sessionStorage.setItem('countries', JSON.stringify(response.data));
	// }
	// const axios = inject('axios');

	// const response = await axios.post('trenitalia/get-countries', {});
	// if (response) sessionStorage.setItem('countries', JSON.stringify(response.data));

	// return response.data;

	// sessionStorage.clear();
}

/**
 * Check if the departure is after the arrival of previus train, if it is all right return true
 * otherwise set the departure according to the arrival (respecting the differences expressed in min, ...) and
 * return departure's Date object
 *
 *
 * @param departure {Object Date}
 * @param arrival {Object Date}
 * @param diffInMin {Number}
 * @param setDepartureObject {Boolean}	- if given number but want an object set it true
 * @param setArrivalObject {Boolean}	- if given number but want an object set it true
 *
 * @returns {Boolean}
 */
export function checkAndSetDepartureAccordingArrival(departure, arrival, { diffInMin=10 } = {}) {
	if (typeof departure == 'string') departure = new Date(departure);
	if (typeof arrival == 'string') arrival = new Date(arrival);

	if( departure.getTime() >= (arrival.getTime() + (diffInMin * 60 * 1000))) return true;

	departure.setFullYear(arrival.getFullYear());
	departure.setMonth(arrival.getMonth());
	departure.setDate(arrival.getDate());
	departure.setHours(arrival.getHours());
	departure.setMinutes(arrival.getMinutes() + diffInMin);

	return departure;
}

export function getOnlyNumbers(text) {
	if(Number.isInteger(text)) return text;
	return text.match(/\d+/)[0];
}

export function rules_checkRequiredFields(value, i18n) {
	if (value) return true;
	return i18n.t('common.required_field', 'Campo obbligatorio')
}
export function rules_checkEmailField(value, i18n, isRequired = false) {
	if (isRequired && !value) return i18n.t('common.required_field', 'Campo obbligatorio');
	if (!isRequired && !value) return true;

	return /.+@.+\..+/.test(value) || i18n.t('rules.email', 'Inserire una email valida');
}